import React from 'react';
import PropTypes from 'prop-types';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { Eye, EyeOff } from 'lucide-react';

const TaskViewFormatter = ({ value }) => {
  const viewed = value === 'Viewed';
  const Icon = viewed ? Eye : EyeOff;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: viewed ? '#2e7d32' : '#616161' }}>
      <Icon size={16} aria-hidden="true" />
      {viewed ? 'Viewed' : 'Not Viewed'}
    </span>
  );
};
TaskViewFormatter.propTypes = { value: PropTypes.string };

export default function TaskViewProvider() {
  return (
    <DataTypeProvider for={['taskViewedByAssignee', 'taskViewedBySupporter']} formatterComponent={TaskViewFormatter} />
  );
}
